export class FailedToResolveNewShelters extends Error {}
